var React = require('react');

function Rss (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 0)"},React.createElement("g",{"className":"fillable","fill":"#F7F7F7"},[React.createElement("circle",{"cx":"6.566","cy":"25.434","r":"3.566","key":0}),React.createElement("path",{"d":"M20.234,29h-5.051c0-6.728-5.454-12.183-12.183-12.183h0v-5.051c9.518,0,17.234,7.716,17.234,17.234Z","key":1}),React.createElement("path",{"d":"M23.8,29c0-11.488-9.312-20.8-20.8-20.8V3c14.359,0,26,11.641,26,26h-5.2Z","key":2})])));
}

Rss.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Rss;

Rss.default = Rss;
